import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SdHeadingComponent } from '@sdvor/seo/ui';
import { UserCompaniesComponent } from '../../components';

@Component({
  selector: 'sd-companies-list-page',
  templateUrl: './companies-list-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SdHeadingComponent, UserCompaniesComponent],
})
export class CompaniesListPageComponent {}
